import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import type { MembershipModule } from '@/services'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/login', name: 'login', component: () => import('@/views/AuthView.vue'), meta: { guest: true } },
    {
      path: '/',
      component: () => import('@/layouts/AppShell.vue'),
      meta: { auth: true },
      children: [
        { path: '', name: 'dashboard', component: () => import('@/views/DashboardView.vue') },
        { path: 'practice', name: 'practice', component: () => import('@/views/PracticeView.vue') },
        {
          path: 'learning-archive',
          name: 'learning-archive',
          component: () => import('@/views/LearningArchiveView.vue'),
        },
        { path: 'wrong-book', name: 'wrong-book', component: () => import('@/views/WrongBookView.vue') },
        {
          path: 'typing',
          name: 'typing',
          component: () => import('@/views/TypingView.vue'),
          meta: { membershipModule: 'typing' },
        },
        {
          path: 'media',
          name: 'media-learning',
          component: () => import('@/views/MediaLearningView.vue'),
          meta: { membershipModule: 'media' },
        },
        {
          path: 'recordings',
          name: 'recordings',
          component: () => import('@/views/RecordingsView.vue'),
          meta: { membershipModule: 'recordings' },
        },
        { path: 'statistics', name: 'statistics', component: () => import('@/views/StatisticsView.vue') },
        { path: 'membership', name: 'membership', component: () => import('@/views/MembershipView.vue') },
        { path: 'profile', name: 'profile', component: () => import('@/views/ProfileView.vue') },
        { path: 'admin', name: 'admin', component: () => import('@/views/AdminView.vue'), meta: { admin: true } },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  await auth.initialize()
  if (to.meta.auth && !auth.isAuthenticated) return { name: 'login', query: { redirect: to.fullPath } }
  if (to.meta.admin && !auth.isAdmin) return { name: 'dashboard' }
  const requestedModule = to.meta.membershipModule as MembershipModule | undefined
  if (requestedModule && !auth.isAdmin && !auth.membership?.entitlements.modules.includes(requestedModule)) {
    return { name: 'membership', query: { required: requestedModule } }
  }
  if (to.meta.guest && auth.isAuthenticated) return { name: 'dashboard' }
})

export default router
